<template>
    <div>
        <HeaderTab :title="$t('invoice.factures_a_regler')" :icon="['fal', 'file-exclamation']" />
        <div class="container-fluid py-3">
            <div class="row">
                <div
                    v-for="group in groups"
                    :key="group.author_rs + '||' + group.tiers_rs"
                    class="col-12 col-md-6 col-xl-4 mb-3"
                >
                    <div class="unpaid-card h-100 d-flex flex-column">
                        <!-- Nom du client -->
                        <div class="text-center font-weight-bold mb-3 text-truncate">{{ group.tiers_rs }}</div>

                        <!-- Liste des factures du groupe -->
                        <div class="flex-fill">
                            <div
                                v-for="inv in group.items"
                                :key="inv.invoice_id"
                                class="d-flex align-items-center py-1 border-bottom small"
                                style="min-width:0"
                            >
                                <!-- Numéro cliquable pour télécharger -->
                                <span
                                    class="font-weight-bold mr-2 flex-shrink-0 text-primary"
                                    style="cursor:pointer"
                                    @click="$emit('download', inv)"
                                >#{{ inv.invoice_num }}</span>

                                <span class="text-muted mr-auto text-truncate" style="min-width:0">{{ inv.invoice_date_formatted }}</span>
                                <span class="text-danger font-weight-bold ml-2 flex-shrink-0">{{ inv.balance_formatted }}</span>
                            </div>
                        </div>

                        <!-- Bouton paiement (désactivé si devise non EUR) -->
                        <span
                            v-b-tooltip.hover
                            :title="group.currency !== 'EUR' ? $t('invoice.paiement_eur_uniquement') : ''"
                            class="d-block"
                        >
                            <b-button
                                variant="primary"
                                block
                                class="mt-3"
                                :disabled="group.currency !== 'EUR'"
                                @click="$emit('pay', group.items.map(i => i._raw))"
                            >
                                {{ $t('invoice.regler') }} {{ groupTotal(group) }}
                            </b-button>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'UnpaidGroups',

    components: {
        HeaderTab: () => import('@/components/HeaderTab'),
    },

    props: {
        // Tableau de groupes { author_rs, tiers_rs, currency, items[] }
        groups: {
            type: Array,
            required: true,
        },
        // Map clé "author_rs||tiers_rs" → montant total formaté
        groupTotals: {
            type: Object,
            default: () => ({}),
        },
    },

    methods: {
        groupTotal(group) {
            return this.groupTotals[group.author_rs + '||' + group.tiers_rs] || ''
        },
    },
}
</script>

<style scoped>
.unpaid-card {
    border: 1px solid var(--primary);
    border-radius: 0.5rem;
    padding: 1rem;
}
</style>
